/**
 * Set the page title.
 * @param title - new title.
 * @param sufix - suffix for the title.
 */
export function setHTMLTitle(title, sufix = '') {
    let titleElement = document.querySelector('title');
    // Create title element if does not exist.
    if (!titleElement) {
        titleElement = document.createElement('title');
        document.head.appendChild(titleElement);
    }
    if (title || sufix) {
        const isFullTitle = title && sufix;
        titleElement.innerText = isFullTitle ? `${title} | ${sufix}` : title || sufix;
    }
}
